import { Component, Input, OnInit, OnChanges, Inject } from '@angular/core';
import { Meta } from '../../angular2-meta';
import { IVisualState } from '../visual/visual.reducer';

@Component({
  selector: 'nns-video-attachment',
  template: `
      <nns-video-player
        *ngIf="isBrowser"
        [attachment]="attachment"
        [maxWidth]="maxWidth"
        [maxHeight]="maxHeight"
      >
      </nns-video-player>
      <nns-video-loader
        *ngIf="!isBrowser"
      ></nns-video-loader>
  `,
  styles: [`
    :host {
      padding:16px;
    }
    nns-video-player {
      min-width:75%;
    }
    @media only screen and (max-width: 768px) {
       nns-video-player {min-width:100%;}
    }
    @media only screen and (max-width: 600px) {
      :host {
        padding:0;
      }
    }
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
  `]
})
export class VideoAttachmentComponent implements OnInit, OnChanges {
  @Input() attachment;
  @Input() share;
  @Input() note;
  @Input() visual:IVisualState;
  maxWidth;
  maxHeight;

  constructor(
    public _meta: Meta,
    @Inject('isBrowser') public isBrowser: boolean
  ) { }

  ngOnChanges() {
    this.setMeta();
    this.setVideoSizes();
  }

  setVideoSizes() {
    if (this.visual.isMobile) {
      this.maxWidth = this.visual.windowWidth;
      this.maxHeight = this.visual.windowHeight - 56 - 50;
    } else {
      this.maxWidth = this.visual.windowWidth - 32;
      this.maxHeight = this.visual.windowHeight - 56 - 32 - 50;
    }
  }

  ngOnInit() {
    this.setVideoSizes();
    this.setMeta();
  }

  setMeta() {
    this._meta.setMetaForAttachment(this.share, this.note, this.attachment);
  }
}
